/* Stuck-scroll recovery — event-driven, runs on user intent only. */
(function () {
  function isShopfloDrawerVisible() {
    var iframes = document.getElementsByTagName('iframe');
    for (var i = 0; i < iframes.length; i++) {
      var f = iframes[i];
      if (!f.src || f.src.indexOf('shopflo') === -1) continue;
      var cs = window.getComputedStyle(f);
      if (cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0') continue;
      var rect = f.getBoundingClientRect();
      if (rect.width < 200 || rect.height < 200) continue;
      if (rect.right < 0 || rect.left >= window.innerWidth) continue;
      if (rect.bottom < 0 || rect.top >= window.innerHeight) continue;
      return true;
    }
    return false;
  }

  function isBodyLocked() {
    return document.body.style.position === 'fixed' || document.body.classList.contains('overflow-hidden');
  }

  function recover() {
    var children = document.body.children;
    for (var i = 0; i < children.length; i++) {
      var d = children[i];
      if (d.tagName === 'DIV' && d.style.zIndex === '9998' && d.style.position === 'fixed') {
        d.click();
        break;
      }
    }

    try {
      if (window.Alpine && window.Alpine.store) {
        var xp = window.Alpine.store('xPopup');
        if (xp && xp.open) xp.open = false;
        var xmc = window.Alpine.store('xMiniCart');
        if (xmc && xmc.open) xmc.open = false;
      }
    } catch (_) {
      /* never break the page */
    }
  }

  function onUserAttempt() {
    if (isBodyLocked() && !isShopfloDrawerVisible()) {
      recover();
    }
  }

  var opts = { passive: true, capture: true };
  window.addEventListener('wheel', onUserAttempt, opts);
  window.addEventListener('touchstart', onUserAttempt, opts);
  window.addEventListener('pointerdown', onUserAttempt, opts);
})();
